import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AUTH_TOKEN_KEY = "aw_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

// Stay signed in: if the webview drops our session cookie (Android clears it on
// storage cleanup / reopen), fall back to a long-lived token stored in localStorage.
api.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem(AUTH_TOKEN_KEY);
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } catch (_) {}
  return config;
});

export function saveAuthToken(token) {
  try { if (token) localStorage.setItem(AUTH_TOKEN_KEY, token); } catch (_) {}
}

export function clearAuthToken() {
  try { localStorage.removeItem(AUTH_TOKEN_KEY); } catch (_) {}
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function hueColor(h) {
  return `hsl(${h ?? 165} 100% 60%)`;
}

// Build a URL-safe channel handle (no spaces) so links never break when shared/tapped.
export function channelSlug(name) {
  return (name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

// Resolve a media reference: absolute URLs pass through, relative /api/... get the backend host.
export function mediaUrl(u) {
  if (!u) return u;
  if (/^https?:\/\//i.test(u)) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u.startsWith("/") ? "" : "/"}${u}`;
}

// Serve right-sized, compressed images from Unsplash/Pexels so thumbnails load fast.
export function optImage(url, w = 640) {
  if (!url || !/^https?:/i.test(url)) return url;
  try {
    const u = new URL(url);
    if (u.hostname.includes("unsplash")) {
      u.searchParams.set("auto", "format");
      u.searchParams.set("fit", "crop");
      u.searchParams.set("w", String(w));
      u.searchParams.set("q", "68");
    } else if (u.hostname.includes("pexels")) {
      u.searchParams.set("auto", "compress");
      u.searchParams.set("cs", "tinysrgb");
      u.searchParams.set("w", String(w));
      u.searchParams.delete("h");
      u.searchParams.delete("dpr");
    } else {
      return url;
    }
    return u.toString();
  } catch (_) { return url; }
}
